import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import {
  loadCompanyJobs,
  loadCompanyJobsFailure,
  loadCompanyJobsSuccess,
  setCompanyJobsFilter,
  initCompanyJobs
} from './actions'
import {
  defaultFilter,
  defaultHasMorePages,
  defaultItems,
  defaultLoading,
  defaultPage,
  defaultCompanyId
} from './defaultState'

const items = handleActions({
  [combineActions(setCompanyJobsFilter, initCompanyJobs)]: () => defaultItems,
  [loadCompanyJobsSuccess]: (state, { payload: { items } }) => ([...state, ...items])
}, defaultItems)

const page = handleActions({
  [combineActions(setCompanyJobsFilter, initCompanyJobs)]: () => defaultPage,
  [loadCompanyJobsSuccess]: (state, { payload: { page } }) => page || state
}, defaultPage)

const loading = handleActions({
  [loadCompanyJobs]: () => true,
  [combineActions(loadCompanyJobsSuccess, loadCompanyJobsFailure)]: () => false
}, defaultLoading)

const filter = handleActions({
  [combineActions(setCompanyJobsFilter, initCompanyJobs)]: () => defaultFilter,
  [setCompanyJobsFilter]: (store, { payload: { filter } }) => filter
}, defaultFilter)

const hasMorePages = handleActions({
  [combineActions(setCompanyJobsFilter, initCompanyJobs)]: () => defaultHasMorePages,
  [loadCompanyJobsSuccess]: (state, { payload: { hasMorePages } }) => hasMorePages
}, defaultHasMorePages)

const companyId = handleActions({
  [loadCompanyJobsSuccess]: (state, { meta: { companyId } }) => companyId
}, defaultCompanyId)

export default combineReducers({ items, page, loading, filter, hasMorePages, companyId })
